import raven from '@didi/raven'
import ravenErrorPlugin from '@didi/raven/dist/plugins/error'
// 引入 pageview 插件
import pageviewPlugin from '@didi/raven/dist/plugins/pageview'

import omegaIdPlugin from '@didi/raven/dist/plugins/omgId'
import ravenPerformancePlugin from '@didi/raven/dist/plugins/performance'

import ravenResourcePlugin from '@didi/raven/dist/plugins/resource'
import { getRavenAttr } from './common'
// 引入 blankObserver 插件
// import ravenBlankObserverPlugin from '@didi/raven/dist/plugins/blankObserver'

import { formatDate } from '@didi/es-mpx-shared/lib/date'
// import { AES_ECB_DECRYPT } from '@/common/crypto'

let appId = 1457

// 上报的数据中自动会添加 oid TODO: 暂时获取不到oid
raven.use(omegaIdPlugin, omgId => {
  // 当系统获取到 oid/omgId 的时候会执行该函数
  console.log('omgId:', omgId)
})

/**
 * raven 文档: http://book.intra.xiaojukeji.com/raven/api/basic.html#trackevent
 */
raven.setConfig({
  appId,
  pool: {
    // 计数合并上报 当只配置 count 时，为计数上报，count 个的埋点上报会被合并上报，同时 raven 会默认启动一个定时器，在适当的时机发送未达到个数的所有埋点
    count: 4,
    //计时合并上报 当只配置 delay 时，为计数上报，delay 毫秒后，这个时间内的埋点会被合并上报
    delay: 3000
  }
  //注：当 count 与 delay 同时存在时，会被认为是计数合并上报埋点，delay 会被当做默认定时器的时间延迟。
})

raven?.setAttrs({
  /*消除报警*/
})
// 发送 pv/uv
raven?.use(pageviewPlugin)
// // 监控页面白屏异常，并自动上报异常信息。
// // 可以在 天眼平台 - 数据统计 - 异常统计中，找到错误名称: _blank_dom_error, 即为该应用的白屏异常日志汇总。
// raven.use(ravenBlankObserverPlugin, {
//   domElem: 'app',
//   waitingTime: 10000
// })
// 监听应用中的异常，并自动上报异常信息。
raven.use(ravenErrorPlugin)
// 自动上报性能
raven.use(ravenPerformancePlugin)
// 监控页面资源加载时长或加载失败情况，并自动上报日志。
// 可以在 天眼平台 - 数据分析 - 资源统计中，找到该应用的资源加载信息汇总。
raven.use(ravenResourcePlugin, {
  // 需要上报加载耗时的资源类型
  tags: ['script'],
  // 需要上报加载失败的资源类型
  errorTags: ['script']
  // // 自定义上报的资源别名
  // alias: (url, tagName) => {
  //   return 'myResourceName'
  // }
  // 需要忽略上报的资源的 host
  // ignoreHost: ['localhost:8081']
})

const proxyApiList = ['trackEvent', 'trackError']
proxyApiList.forEach(api => {
  const raw = raven[api].bind(raven)
  raven[api] = function(eventId, eventLabel, attrs) {
    // 增加路径判空
    const currentPages = getCurrentPages() || []
    const default_attr = {
      page_url: currentPages?.[currentPages?.length - 1]?.route,
      event_time: formatDate('yyyy-MM-dd hh:mm:ss', new Date())
    }
    if (api === 'trackError') {
      /**
       * 修改固定三参数模式为兼容两参数模式
       * 三参数模式 type trackError(name: string, error: Error, attrs: object): IRavenResponsePromise;
       * 两参数模式 type trackError(name: string, attrs: object): IRavenResponsePromise;
       */
      if (eventLabel instanceof Error) {
        attrs = Object.assign({}, attrs || {}, default_attr)
      } else {
        eventLabel = Object.assign({}, eventLabel || {}, default_attr)
      }
    } else if (api === 'trackEvent') {
      // 固定两个个参数
      eventLabel = Object.assign({}, eventLabel || {}, default_attr)
    }
    return raw(eventId, eventLabel, attrs)
  }
})

const commonAttrs = raven.getAttrs()
getRavenAttr(commonAttrs)?.then(res => {
  raven.setAttrs(res)
})

// 初始化raven的uid和手机号的方法，可以从手机号的纬度进行查询
export function addRavenPhoneAndUid(data) {
  // const decryptPhone = AES_ECB_DECRYPT(phone)
  const { uid, phone } = data || {}
  raven.setConfig({
    uid,
    // phone: decryptPhone
  })
}

export default raven
